import { FormInput } from "components/ProjectNonSpecificComponents/Elements/FormElements/FormInput"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import React from "react"
import { useTranslation } from "react-i18next"
import Checkbox from "../../Global/atoms/Checkbox"
interface Props {
	tooltipIsRichText?: boolean
	tooltipText?: string
	onCheckboxChange?: (checked: boolean) => void
	onInputChange?: (text: string) => void
}
const TooltipEditor = ({
	tooltipIsRichText = false,
	tooltipText = "",
	onCheckboxChange = () => {},
	onInputChange = () => {},
}: Props) => {
	const { t } = useTranslation()
	const { isMobile } = useScreenType()
	return (
		<div className="px-4 py-2">
			<div
				className={concatWithSpaces(
					isMobile ? "flex-col" : "flex-row",
					"flex whitespace-nowrap w-full pb-2 justify-between"
				)}
			>
				<p className="text-sm pr-1 pt-1">{t(`forms.tooltip.userSideTooltip`)}</p>
				<div className="flex flex-row">
					<p className="text-sm pr-1 pt-1">{t("rawText.rich-text")}</p>
					<Checkbox checked={tooltipIsRichText} onCheck={onCheckboxChange} />
				</div>
			</div>

			<FormInput
				multiline
				wide
				value={tooltipText}
				onValueChange={onInputChange}
				richText={tooltipIsRichText}
			/>
		</div>
	)
}

export default TooltipEditor
